require('./helpers');

const Timer = require('./timer');

let Notifier = require('./notifier');

class Room {
	constructor(chat, wsroom){
		let self = this;
		this.chat = chat;
		this.wsroom = wsroom;
		this.unread = 0;
		this.messages = [];
		this.typing = [];
		this.lastPM = null;
		this.timerTyping = new Timer(function(){
			self.sendTyping(false);
		});
	}

	makeSysMessage(msg){
		return {
			type: 'sysmessage',
			time: Date.now(),
			body: msg,
		};
	}

	onSysMessage(message){
		this.addMessage(this.makeSysMessage(message));
	}

	onMessage(dt){
		//let arr = ['aquamarine', 'steelblue', 'skyblue', 'sandybrown', 'powderblue'];
		//let arr = ['chartreuse', 'cornflowerblue', 'darkcyan', 'cyan', 'deepskyblue', 'dodgerblue', 'greenyellow'];
		let msg = {
			time: dt.time*1000,
			from: {
				id: dt.from,
				nick: dt.from_login,
				color: dt.color,
			},
			body: dt.message,
		};

		if (dt.to != 0){
			let mto = this.wsroom.getMemberById(dt.to);

			msg.type = 'message_private';
			msg.to = {
				id: dt.to,
				nick: mto.name,
				color: mto.color,
			};

			if (dt.from != this.wsroom.getMyMemberId()){
				this.lastPM = dt.from;
			}
		}
		else if (dt.style == MessageStyle.message || dt.style == MessageStyle.offtop){
			let prevmsg = this.messages[this.messages.length - 1];

			msg.type = dt.style == MessageStyle.message ? 'message' : 'message_offtop';
			msg.continuous = prevmsg && (prevmsg.type == 'message' || prevmsg.type == 'message_offtop') && prevmsg.from.id == dt.from;
		}
		else if (dt.style == MessageStyle.me){
			msg.type = 'message_me';
		}
		else if (dt.style == MessageStyle.event){
			msg.type = 'message_event';
		}

		this.addMessage(msg);

		if (this.wsroom.getMyMemberNick() != '' && dt.message.indexOf('@' + this.wsroom.getMyMemberNick()) != -1){
			Notifier.mention(this.wsroom.getTarget(), dt.from_login, dt.message);
		} else {
			Notifier.message(this.wsroom.getTarget(), dt.from_login, dt.message);
		}
	}

	onJoined(){

	}

	onLeave(){
		this.addMessage(this.makeSysMessage('Вы отключились от комнаты'));
	}

	onUserStatusChanged(dt){
		dt.old_name = dt.data;
		let msg = {
			time: Date.now(),
			user: dt,
		};

		switch (dt.status){
			case UserStatus.bad:
				this.addMessage(this.makeSysMessage('Bad userstatus. WTF???'));
				break;

			case UserStatus.online:
				if (dt.member_id != this.wsroom.getMyMemberId()){
					msg.type = 'status_online';
					this.addMessage(msg);
					Notifier.online(this.wsroom.getTarget(), dt.name, dt.girl ? 'пришла в комнату' : 'пришел в комнату');
				} else {
					this.addMessage(this.makeSysMessage('Вы пришли в комнату'));
				}
				break;

			case UserStatus.offline:
				if (dt.member_id != this.wsroom.getMyMemberId()){
					msg.type = 'status_offline';
					this.addMessage(msg);
				} else {
					this.addMessage(this.makeSysMessage('Вы покинули комнату'));
				}
				this.updateTypingList();
				break;

			case UserStatus.nick_change:
				msg.type = 'status_change_nick';
				this.addMessage(msg);
				break;

			case UserStatus.gender_change:
				if (dt.name == ''){
					this.addMessage(this.makeSysMessage('Вы сменили пол на ' + (dt.girl ? 'женский' : 'мужской')));
				} else {
					msg.type = 'status_change_gender';
					this.addMessage(msg);
				}
				break;

			case UserStatus.color_change:
				msg.type = 'status_change_color';
				this.addMessage(msg);
				break;

			case UserStatus.typing:
			case UserStatus.stop_typing:
				this.updateTypingList();
				break;
		}

		this.chat.onOnlineListChanged(this, this.wsroom.getMembers());
	}

	addMessage(msg){
		this.messages.push(msg);
		this.chat.onChatMessage(this, msg);
	}

	clearMessages(){
		this.messages = [];
	}

	getMembers(){
		return this.wsroom.getMembers();
	}

	getMessages(){
		return this.messages;
	}

	getTypingMembers(){
		return this.typing;
	}

	setTyping(val){
		if (val){
			if (!this.timerTyping.isStarted()){
				this.sendTyping(true);
			}
			this.timerTyping.start(5000);
		} else {
			this.timerTyping.stop();
			this.sendTyping(false);
		}
	}

	sendTyping(val){
		if (this.wsroom.getMyMemberNick() != ''){
			this.wsroom.changeStatus(val ? UserStatus.typing : UserStatus.stop_typing);
		}
	}

	updateTypingList(){
		let list = [];
		let members = this.wsroom.getMembers();
		for (let i in members){
			if (members[i].typing && members[i].member_id != this.wsroom.getMyMemberId()){
				list.push(members[i]);
			}
		}
		this.typing = list;
		this.chat.onTypingListChanged(this, this.typing);
	}

	getLastPMMemberId(){
		return this.lastPM;
	}
}

module.exports = Room;
